// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Methodology_fadeIn__1--pA","methodologyContent":"Methodology_methodologyContent__3NFQI"};